import React from 'react';

const Section = ({ 
  children, 
  className = '', 
  bg = 'cream', 
  id 
}) => {
  const bgColors = {
    cream: 'bg-brand-cream',
    white: 'bg-white',
    navy: 'bg-brand-navy text-white',
    teal: 'bg-brand-teal text-white',
  };

  return (
    <section id={id} className={`py-16 md:py-24 ${bgColors[bg]} ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {children}
      </div>
    </section>
  );
};

export default Section;